import { Model, belongsTo, hasMany } from 'miragejs';

export default Model.extend({
  cmsCreatorId: belongsTo('user', { inverse: 'children' }),
  cmsLockerId: belongsTo('user', { inverse: 'children' }),
  cmsModifierId: belongsTo('user', { inverse: 'children' }),
  cmsOwnerId: belongsTo('user', { inverse: 'children' }),
  coopTypes: hasMany('category', { inverse: 'children' }),
});
